import { BaseComponent } from '../core/BaseComponent';

export interface DropdownOptions {
  autoClose: boolean;
  offset: [number, number];
  trigger: 'click' | 'hover';
  onShow?: (instance: Dropdown) => void;
  onHide?: (instance: Dropdown) => void;
}

export interface DropdownState {
  showing: boolean;
}

export class Dropdown extends BaseComponent<DropdownOptions, DropdownState> {
  private menu: HTMLElement | null = null;
  private toggle: HTMLElement | null = null;

  protected getDefaultOptions(): DropdownOptions {
    return {
      autoClose: true,
      offset: [0, 8],
      trigger: 'click'
    };
  }
  
  protected init(): void {
    super.init();
    this.menu = this.element.querySelector('.dropdown-menu');
    this.toggle = this.element.querySelector('[data-fz-toggle="dropdown"]');
  }
  
  protected bindEvents(): void {
    if (!this.toggle) return;

    if (this.options.trigger === 'click') {
      this.toggle.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        this.toggleMenu();
      });
    } else {
      this.element.addEventListener('mouseenter', () => this.show());
      this.element.addEventListener('mouseleave', () => this.hide());
    }
    
    if (this.options.autoClose) {
      document.addEventListener('click', (e) => {
        if (!this.element.contains(e.target as Node)) {
          this.hide();
        }
      });
    }
  }
  
  public toggleMenu(): void {
    this.state.showing ? this.hide() : this.show();
  }

  public show(): void {
    if (this.state.showing || !this.menu || !this.toggle) return;
    
    this.state.showing = true;
    this.positionMenu();
    this.menu.classList.add('show');
    this.toggle.setAttribute('aria-expanded', 'true');
    
    if (this.options.onShow) this.options.onShow(this);
    this.emit('show');
  }
  
  public hide(): void {
    if (!this.state.showing || !this.menu || !this.toggle) return;
    
    this.state.showing = false;
    this.menu.classList.remove('show');
    this.toggle.setAttribute('aria-expanded', 'false');
    
    if (this.options.onHide) this.options.onHide(this);
    this.emit('hide');
  }
  
  private positionMenu(): void {
    if (!this.menu || !this.toggle) return;
    const toggleRect = this.toggle.getBoundingClientRect();
    
    const top = toggleRect.bottom + this.options.offset[1];
    const left = toggleRect.left + this.options.offset[0];
    
    this.menu.style.position = 'fixed';
    this.menu.style.top = `${top}px`;
    this.menu.style.left = `${left}px`;
    this.menu.style.zIndex = '1000';
  }
}
